import { ValueOf } from '@/types/util';

export const ETransactionType = {
  SELF_CHARGE: 'セルフチャージ',
  CODE_PAYMENT: 'コード決済',
  CODE_PAYMENT_CANCEL: 'コード決済取消',
  PURCHASE_GIFT_CERTIFICATE: '商品券購入',
  GIFT_BALANCE_ADJUSTMENT_IN: '商品券残高調整(加算)',
  GIFT_BALANCE_ADJUSTMENT_OUT: '商品券残高調整(減算)',
  GIFT_BALANCE_EXPIRED: '商品券残高失効',
} as const;

export const ETransactionDetailType = {
  BANK_PAY_CHARGE: 'Bank Payチャージ',
  POINT_CHARGE: 'ポイントチャージ',
  APPLE_PAY_CHARGE: 'Apple Payチャージ',
  APPLE_PAY_ENTRY: 'Apple Pay取引登録',
  HOUSE_PREPAID_SETTLEMENT: 'ハウスプリペイド決済',
  HOUSE_PREPAID_SETTLEMENT_CANCEL: 'ハウスプリペイド決済取消',
  HOUSE_PREPAID_PURCHASE_GIFT: 'ハウスプリペイド商品券購入',
  GIFT_CERTIFICATE_SETTLEMENT: '商品券決済',
  GIFT_CERTIFICATE_SETTLEMENT_CANCEL: '商品券決済取消',
  SPLIT_SETTLEMENT: '商品券併用決済',
  SPLIT_SETTLEMENT_CANCEL: '商品券併用決済取消',
  GIFT_BALANCE_ADJUSTMENT_IN: '商品券残高調整(加算)',
  GIFT_BALANCE_ADJUSTMENT_OUT: '商品券残高調整(減算)',
  BALANCE_EXPIRED: '商品券残高失効',
} as const;

/** 表示用（プルダウン値域と同一） */
export const ETransactionTypeDisplay = ETransactionType;
export const ETransactionDetailTypeDisplay = ETransactionDetailType;

export type TransactionTypeKey = keyof typeof ETransactionType;
export type TransactionTypeValue = ValueOf<typeof ETransactionType>;

export type TransactionDetailTypeKey = keyof typeof ETransactionDetailType;
export type TransactionDetailTypeValue = ValueOf<typeof ETransactionDetailType>;

export const transactionTypeKeys = Object.keys(ETransactionType) as TransactionTypeKey[];

/** 商品券決済系（商品券決済・併用決済＋各取消）の取引詳細区分。
 * ヘッダの調整額（商品券利用額）併記と商品券情報カードの決済系表示の判定に使う */
export const giftSettlementDetailTypeKeys: TransactionDetailTypeKey[] = [
  'GIFT_CERTIFICATE_SETTLEMENT',
  'GIFT_CERTIFICATE_SETTLEMENT_CANCEL',
  'SPLIT_SETTLEMENT',
  'SPLIT_SETTLEMENT_CANCEL',
];

export const transactionDetailTypeKeys = Object.keys(ETransactionDetailType) as TransactionDetailTypeKey[];

/** v-select用items */
export const transactionTypeItems = transactionTypeKeys
  .map((key) => ({
    title: ETransactionType[key],
    value: key,
  }));

export const transactionDetailTypeItems = transactionDetailTypeKeys
  .map((key) => ({
    title: ETransactionDetailType[key],
    value: key,
  }));
